import { onMount, onCleanup, createSignal, Show, For, createEffect } from "solid-js";
import { createStore } from "solid-js/store";

import { Pencil } from "./Icons";

export const AddressEditor = ( props ) => {
	const [active, setActive] = createSignal( false );

	const [store, setStore] = createStore( { ...( props.address ?? { name: "", addr1: "", addr2: "", town: "", county: "", postcode: "" } ) } )

	const setAddress = ( addr ) => {
		setStore( {
			name: addr.Company,
			addr1: addr.Line1,
			addr2: addr.Line2,
			town: addr.City ?? addr.Neighbourhood ?? addr.Line3,
			county: addr.Province,
			postcode: addr.PostalCode,
		} )
	};

	createEffect( () => props.isActive && props.isActive( active() ) );

	return (
		<div onClick={() => setActive( true )} class="w-full flex flex-col py-3" classList={props.classList}>
			<Show when={active()}>
				<LoqateSearch onAddressSelected={setAddress} />

				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">Company/Name:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="name" value={store?.name ?? ''} onChange={e => setStore( "name", e.target.value )} /></label>
				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">Line 1:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="addr1" value={store?.addr1 ?? ''} onChange={e => setStore( "addr1", e.target.value )} /></label>
				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">Line 2:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="addr2" value={store?.addr2 ?? ''} onChange={e => setStore( "addr2", e.target.value )} /></label>
				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">Town/City:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="town" value={store?.town ?? ''} onChange={e => setStore( "town", e.target.value )} /></label>
				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">County:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="county" value={store?.county ?? ''} onChange={e => setStore( "county", e.target.value )} /></label>
				<label class="grid grid-cols-[1fr_3fr] items-center gap-2 my-2"><span class="text-right">Postcode:</span><input type="text" class="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary" name="postcode" value={store?.postcode ?? ''} onChange={e => setStore( "postcode", e.target.value )} /></label>
				
				<div class="flex flex-nowrap justify-end gap-2 mt-4">
				<button type="button" class="rias bg-gray-100 text-gray-800 hover:bg-gray-800 hover:text-gray-100" 
					onClick={( e ) => {
						e.stopPropagation();
						setActive( false );
					}}>Cancel</button>

				<button type="button" class="rias bg-blue-500 text-white hover:bg-blue-600"
					onClick={( e ) => {
						e.stopPropagation();
						props.setAddress( { ...store } );
						setActive( false );
						}}>Save</button>
					</div>
			</Show>
			<Show when={!active()}>
				<Show when={!Object.values( store ).every( v => !v )}
					fallback={<button type="button" class="text-blue-600 underline">Add address</button>}>
					<div class="text-md flex flex-nowrap items-center group cursor-pointer">
						<span class="font-bold">{store.name}</span>&nbsp;{[store.addr1, store.addr2, store.town, store.county].filter( Boolean ).join( ', ' )}{store.postcode && ` ${store.postcode}`}

						<Pencil width="30px" class="ml-3 opacity-0 group-hover:opacity-100 group-hover:text-blue-600" />
					</div>
				</Show>
			</Show>
		</div>
	);
};



const LoqateSearch = ( props ) => {
	const [query, setQuery] = createSignal( "" );
	const [suggestions, setSuggestions] = createSignal( [] );
	const [showDropdown, setShowDropdown] = createSignal( false );

	const API_KEY = "ZG93-FG79-DB33-PR87";

	// Step 1: Find addresses as the user types
	const handleInput = async ( e ) => {
		const value = e.target.value;
		setQuery( value );

		if ( value.length < 3 ) {
			setSuggestions( [] );
			return;
		}

		try {
			const res = await fetch(
				`https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws?Key=${API_KEY}&Text=${encodeURIComponent( value )}`
			);
			const data = await res.json();
			setSuggestions( data.Items || [] );
			setShowDropdown( true );
		} catch ( err ) {
			console.error( "Loqate Find Error:", err );
		}
	};

	// Step 2: Retrieve full details when a suggestion is clicked
	const selectAddress = async ( id ) => {
		try {
			const res = await fetch(
				`https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws?Key=${API_KEY}&Id=${id}`
			);
			const data = await res.json();

			if ( data.Items && data.Items.length > 0 ) {
				const fullAddress = data.Items[0];

				// Return the full object to the parent via the prop function
				props.onAddressSelected( fullAddress );

				// Reset UI
				//setQuery( fullAddress.Label );
				setShowDropdown( false );
			}
		} catch ( err ) {
			console.error( "Loqate Retrieve Error:", err );
		}
	};

	return (
		<div class="w-full relative overflow-visible">
			<div class="my-2 flex">
				<div class="flex shrink-0 items-center rounded-l-md px-3 text-base bg-gray-200 outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6">Search:</div>

				<input id="address-search" type="text" value={query()}
					onInput={handleInput}
					placeholder="Start typing an address..."
					class="-ml-px block w-full grow rounded-r-md bg-white p-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6" />
			</div>

			<Show when={showDropdown()}>
				<ul class="absolute bg-white border border-gray-800 list-none m-0 p-0 w-full z-10 shadow-2xl"				>
					<For each={suggestions()}>
						{( item: { Text: string, Description: string, Id: string } ) => (
							<li onClick={() => selectAddress( item.Id )}
								class="px-2 py-1 cursor-pointer border-b border-gray-200 hover:bg-gray-100">
								{item.Text} {item.Description}
							</li>
						)}
					</For>
					<Show when={suggestions().length === 0}>
						<li class="px-2 py-1 text-gray-500">No results found</li>
					</Show>
				</ul>
			</Show>
		</div>
	);
};

